
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.575 6.985a1.304 1.304 0 010-2.609h.87A1.304 1.304 0 013.14 3.072c0-.72.584-.87 1.304-.87h5.653c2.479 0 1.918.435 4.962.87v7.391c-2.13 0-4.528 3.913-4.528 7.392 0 1.375-1.903 1.887-2.608-.625-.435-1.55.87-4.593.87-4.593H1.835A1.304 1.304 0 01.53 11.333c0-.72.585-1.74 1.305-1.74h.87a1.304 1.304 0 110-2.608h.869zm15.909 4.783h-4.348V1.333h4.348v10.435z","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M17.609 3.508a.218.218 0 100-.435.218.218 0 000 .435z","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    